import React from 'react';
import ProductCategoryPage from '../../components/ProductsList/ProductCategoryPage';
import { trafficSafetyProducts } from '../../data/products';

export default function TrafficSafety() {
  return (
    <ProductCategoryPage
      title="도로 안전경보시스템"
      subtitle={"운전자에게 긴급 상황을 알리고 \n도로 작업 현장의 안전을 확보합니다"}
      products={trafficSafetyProducts}
    />
  );
}
